var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "divBox" }, [
    _c(
      "div",
      { staticClass: "content" },
      [
        _c(
          "div",
          { staticClass: "left" },
          [
            _c(
              "el-card",
              { staticClass: "left-card" },
              [
                _c("LeftNavigation", {
                  attrs: {
                    componentStatus: _vm.initData,
                    imageUrl: _vm.imageUrl,
                    user: _vm.user,
                  },
                  on: { pageJump: _vm.pageJump, getImageUrl: _vm.getImageUrl },
                }),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "right" },
          [
            _c(
              "el-card",
              { staticClass: "right-card" },
              [
                _c("formItemDataList", {
                  ref: "formItemData",
                  attrs: { componentStatus: _vm.initData, user: _vm.user },
                  on: { getPhoto: _vm.getPhoto, hiddenSave: _vm.hiddenSave },
                }),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c("el-card", { staticClass: "pushBox" }, [
          _c(
            "div",
            {
              on: {
                "&scroll": function ($event) {
                  return _vm.getScroll($event)
                },
              },
            },
            [
              _vm.list.length > 0
                ? _c("div", { staticClass: "title mb20" }, [_vm._v("邀请提示")])
                : _vm._e(),
              _vm._v(" "),
              _vm._l(_vm.list, function (item, index) {
                return _c("div", { key: index, staticClass: "send-box" }, [
                  _c("div", { staticClass: "send-content" }, [
                    _c("img", {
                      staticClass: "img",
                      attrs: { src: item.enterprise.logo, alt: "" },
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "text" }, [
                      _c("div", [
                        _vm._v(_vm._s(item.enterprise.enterprise_name)),
                      ]),
                      _vm._v(" "),
                      item.types == 0
                        ? _c("span", [_vm._v("邀请您发送个人简历信息")])
                        : _c("span", [
                            _vm._v("您当前所在企业，邀请您完善个人档案信息"),
                          ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "footer" }, [
                    _c(
                      "div",
                      {
                        staticClass: "refuse",
                        on: {
                          click: function ($event) {
                            return _vm.putPerfectRefuse(item)
                          },
                        },
                      },
                      [_vm._v("拒绝")]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "refuse1",
                        on: {
                          click: function ($event) {
                            return _vm.putPerfectAgree(item)
                          },
                        },
                      },
                      [_vm._v("发送")]
                    ),
                  ]),
                ])
              }),
              _vm._v(" "),
              _c(
                "div",
                [
                  _vm.h_list.length > 0
                    ? _c("div", { staticClass: "title" }, [_vm._v("邀请记录")])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm._l(_vm.h_list, function (val, index) {
                    return _c("div", { key: index, staticClass: "h-box" }, [
                      _c("img", {
                        staticClass: "img",
                        attrs: { src: val.enterprise.logo, alt: "" },
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "text" }, [
                        _c("div", [
                          _vm._v(_vm._s(val.enterprise.enterprise_name)),
                        ]),
                        _vm._v(" "),
                        val.status == 1 && val.types == 0
                          ? _c("span", { staticStyle: { color: "#1890ff" } }, [
                              _vm._v("已发送个人简历信息"),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        val.status == 1 && val.types == 1
                          ? _c("span", { staticStyle: { color: "#1890ff" } }, [
                              _vm._v("已完善个人档案信息"),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        val.status == 2 && val.types == 0
                          ? _c("span", { staticStyle: { color: "#ed4014" } }, [
                              _vm._v("拒绝发送个人简历信息"),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        val.status == 2 && val.types == 1
                          ? _c("span", { staticStyle: { color: "#ed4014" } }, [
                              _vm._v("拒绝完善个人档案信息"),
                            ])
                          : _vm._e(),
                      ]),
                    ])
                  }),
                ],
                2
              ),
              _vm._v(" "),
              _vm.h_list.length == 0 && _vm.list.length == 0
                ? _c("div", { staticClass: "default" }, [
                    _c("img", {
                      staticClass: "def-img",
                      attrs: {
                        src: require("../../../assets/images/def1.png"),
                        alt: "",
                      },
                    }),
                    _vm._v(" "),
                    _c("div", [_vm._v("暂无企业邀请信息～")]),
                  ])
                : _vm._e(),
            ],
            2
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "cr-bottom-button btn-shadow" },
          [
            _c(
              "el-button",
              { attrs: { size: "small" }, on: { click: _vm.restFn } },
              [_vm._v("重置")]
            ),
            _vm._v(" "),
            _c(
              "el-button",
              {
                attrs: { type: "primary", size: "small" },
                on: { click: _vm.submit },
              },
              [_vm._v("保存")]
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }